(function () {
  var labels = {
    'shopify-pc__banner__btn-manage-prefs': 'Configurează',
    'shopify-pc__banner__btn-accept': 'Acceptă',
  };
  var buttonIds = Object.keys(labels);
  var buttonSelector = '#' + buttonIds.join(', #');
  var buttons = {};
  var buttonObserver;

  function isConnected(button) {
    return 'isConnected' in button ? button.isConnected : document.documentElement.contains(button);
  }

  function watchButtons() {
    if (!buttonObserver) return;

    buttonObserver.disconnect();
    buttonIds.forEach(function (id) {
      if (buttons[id]) buttonObserver.observe(buttons[id], { childList: true, subtree: true });
    });
  }

  function localizeButton(button) {
    if (button && button.textContent.trim() !== labels[button.id]) {
      button.textContent = labels[button.id];
    }
  }

  function localizePrivacyButtons() {
    buttonIds.forEach(function (id) {
      buttons[id] = document.getElementById(id);
      localizeButton(buttons[id]);
    });
  }

  function hasMissingButtons() {
    var missing = false;
    var changed = false;

    buttonIds.forEach(function (id) {
      var button = buttons[id];
      if (button && (button.id !== id || !isConnected(button))) {
        buttons[id] = document.getElementById(id);
        localizeButton(buttons[id]);
        changed = true;
      }
      if (!buttons[id]) missing = true;
    });

    if (changed) watchButtons();
    return missing;
  }

  function discoverButtons(root) {
    if (root.nodeType !== 1 || !isConnected(root)) return;

    function rememberButton(button) {
      if (!buttons[button.id]) {
        buttons[button.id] = button;
        localizeButton(button);
        buttonObserver.observe(button, { childList: true, subtree: true });
      }
    }

    if (Object.prototype.hasOwnProperty.call(labels, root.id)) rememberButton(root);
    root.querySelectorAll(buttonSelector).forEach(rememberButton);
  }

  function handleButtonMutations(mutations) {
    mutations.forEach(function (mutation) {
      buttonIds.forEach(function (id) {
        var button = buttons[id];
        if (button && isConnected(button) && button.contains(mutation.target)) localizeButton(button);
      });
    });
  }

  function handlePrivacyMutations(mutations) {
    // Only discover missing/replaced buttons here; their own observer handles label changes.
    if (!hasMissingButtons()) return;

    for (var i = 0; i < mutations.length; i += 1) {
      for (var j = 0; j < mutations[i].addedNodes.length; j += 1) {
        discoverButtons(mutations[i].addedNodes[j]);
        if (!hasMissingButtons()) return;
      }
    }
  }

  localizePrivacyButtons();

  if ('MutationObserver' in window) {
    buttonObserver = new MutationObserver(handleButtonMutations);
    watchButtons();
    new MutationObserver(handlePrivacyMutations).observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  } else {
    document.addEventListener('DOMContentLoaded', localizePrivacyButtons);
  }
})();
